export const yupCs = {
    mixed: {
        default: 'Hodnota je neplatná',
        required: 'Pole je povinné',
        oneOf: 'Pole musí obsahovat jednu z následujících hodnot: ${values}',
        notOneOf: 'Pole nesmí obsahovat žádnou z následujících hodnot: ${values}',
        notType: 'Pole je povinné',
    },
    string: {
        length: 'Pole musí obsahovat přesně ${length} znaků',
        min: 'Pole musí obsahovat minimálně ${min} znaků',
        max: 'Pole musí obsahovat maximálně ${max} znaků',
        matches: 'Pole musí splňovat pravidlo: "${regex}"',
        email: 'Emailová adresa není platná',
        url: 'URL adresa není platná',
        trim: 'Pole nesmí obsahovat mezery',
        lowercase: 'Pole musí obsahovat jen malá písmena',
        uppercase: 'Pole musí obsahovat jen velká písmena',
    },
    number: {
        min: 'Hodnota musí být větší nebo rovno ${min}',
        max: 'Hodnota musí být menší nebo rovno ${max}',
        lessThan: 'Hodnota musí být menší než ${less}',
        moreThan: 'Hodnota musí být větší než ${more}',
        notEqual: 'Hodnota se nesmí rovnat "${notEqual}"',
        positive: 'Hodnota musí být kladné číslo',
        negative: 'Hodnota musí být záporné číslo',
        integer: 'Hodnota musí být celé číslo',
    },
    date: {
        min: 'Hodnota musí být po ${min}',
        max: 'Hodnota musí být před ${max}',
    },
    boolean: {},
    object: {
        noUnknown: 'Seznam nesmí obsahovat nespecifikované klíče',
    },
    array: {
        min: 'Seznam musí obsahovat alespoň ${min} položky',
        max: 'Seznam musí obsahova maximálně ${max} položky',
    },
};
